import {memo, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import GoogleOneTapLoader from '@s-ui/react-google-one-tap-loader'

import AuthenticateWithGoogle from './authenticateWithGoogle.js'

const GoogleOneTapLogin = ({onPrompt = () => {}, onAccessToken = () => {}, origin, prompted = false}) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  const isHttps = window.location.protocol === 'https:'
  const isLocalhost = window.location.hostname === 'localhost'

  // Google SDKs will cause an exception on http, like test environments.
  // Nevertheless http://localhost is allowed
  const canLoadGoogleScripts = isHttps || isLocalhost

  return canLoadGoogleScripts ? (
    <GoogleOneTapLoader
      render={() => (
        <AuthenticateWithGoogle onPrompt={onPrompt} onAccessToken={onAccessToken} prompted={prompted} origin={origin} />
      )}
      onTimeout={() => {}}
    />
  ) : null
}

GoogleOneTapLogin.displayName = 'GoogleOneTapLogin'
GoogleOneTapLogin.propTypes = {
  onPrompt: PropTypes.func.isRequired,
  onAccessToken: PropTypes.func.isRequired,
  origin: PropTypes.string,
  prompted: PropTypes.bool
}

export default memo(GoogleOneTapLogin)
